import { render, staticRenderFns } from "./ChannelFlowDetails.vue?vue&type=template&id=6b89a0da&scoped=true&"
import script from "./ChannelFlowDetails.vue?vue&type=script&lang=js&"
export * from "./ChannelFlowDetails.vue?vue&type=script&lang=js&"
import style0 from "./ChannelFlowDetails.vue?vue&type=style&index=0&id=6b89a0da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b89a0da",
  null
  
)

component.options.__file = "ChannelFlowDetails.vue"
export default component.exports